"use client";
import { RiCodeSSlashLine } from "react-icons/ri";
import { SocialLinksTooltip } from "../common/social-links";

export default function MockupFrame() {
  return (
    <div className="flex relative h-full items-center justify-center mockup-glow p-4 rounded-2xl dark:bg-violet-300 bg-gray-100">
      {/* <div className="w-[420px] h-[420px] dark:bg-[#071018] bg-gray-300 rounded-2xl space-y-2 flex flex-col items-center justify-center border"> */}
      <div className="dark:bg-[#071018] p-2 gap-10 rounded-xl bg-gray-300 h-full flex flex-col items-center justify-center">
        <p className="text-foreground text-6xl">
          {/* Code Script */}
          <RiCodeSSlashLine />
        </p>

        <SocialLinksTooltip />
      </div>
    </div>
  );
}
